(function () {
  function wrapWords(node) {
    Array.prototype.slice.call(node.childNodes).forEach(function (child) {
      if (child.nodeType === Node.TEXT_NODE) {
        const parts = child.textContent.split(/(\s+)/)
        const frag = document.createDocumentFragment()

        parts.forEach(function (part) {
          if (part === '') return
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part))
          } else {
            const span = document.createElement('span')
            span.className = 'word-reveal__word'
            span.textContent = part
            frag.appendChild(span)
          }
        })

        node.replaceChild(frag, child)
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        wrapWords(child)
      }
    })
  }

  function init() {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll('.word-reveal').forEach(function (el) {
      if (el.dataset.wordRevealReady) return
      el.dataset.wordRevealReady = 'true'
      wrapWords(el)

      const words = el.querySelectorAll('.word-reveal__word')
      if (!words.length) return

      const section = el.closest('[data-section-id]') || el.parentElement

      ScrollTrigger.create({
        trigger: section,
        start: 'center bottom',
        end: 'bottom bottom',
        scrub: true,
        onUpdate: function (self) {
          const activeCount = Math.round(self.progress * words.length)
          words.forEach(function (word, i) {
            word.classList.toggle('is-visible', i < activeCount)
          })
        }
      })
    })
  }

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    init()
  } else {
    window.addEventListener('load', init)
  }
})()
